var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{attrs:{"mw0":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('registrar-create-update',{attrs:{"registrar-data":{ id: _vm.id }},on:{"unsavedChanges":_vm.setUnsavedChanges,"success":_vm.success,"cancel":_vm.back}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }